import React, { lazy } from 'react';
import { Settings, Palette, Clock, Zap, Globe, Award, Users, Store, FileText } from 'lucide-react';
import { Container } from '../Container';
import { motion } from 'framer-motion';
const BENEFITS = [{
  icon: Settings,
  title: 'Factory Direct Control',
  desc: 'No middleman. More control over quality, timelines, and production details for teams, leagues, and organizations.',
  image: 'https://cdn.magicpatterns.com/uploads/jTgmXwSMwAGxKcC6kkYK9B/gcu-why-factory-direct-control.png'
}, {
  icon: Palette,
  title: 'Free Initial Art Mockups',
  desc: 'Submit your colors, logos, and design ideas so our art team can create initial mockups before you move forward.',
  image: 'https://cdn.magicpatterns.com/uploads/koQqzWSH5L4V15Qg3LzqRA/gcu-why-free-initial-art-mockups.png'
}, {
  icon: Clock,
  title: 'Fast Turn Times',
  desc: 'Built for programs that need quality custom uniforms without dragging out the ordering process.',
  image: 'https://cdn.magicpatterns.com/uploads/2DNyZBxEbLdBfkK1vLxLjk/gcu-why-fast-turn-times.png'
}, {
  icon: Zap,
  title: 'Free Rush',
  desc: 'Ask us about free rush options when your program, league, or team is working against a tight deadline.',
  image: 'https://cdn.magicpatterns.com/uploads/epTo1XgAffF3e5efXscy42/gcu-why-free-rush.png'
}, {
  icon: Globe,
  title: 'Overseas Pricing with USA Support',
  desc: 'Get overseas production value with a USA-based support team helping with design, communication, and order details.',
  image: 'https://cdn.magicpatterns.com/uploads/1orLMVVuafBpCe43hWhnfc/gcu-why-overseas-pricing-usa-support.png'
}, {
  icon: Award,
  title: '15 Year Track Record',
  desc: 'PTS has helped teams, leagues, clubs, schools, and organizations with custom gear for over 15 years.',
  image: 'https://cdn.magicpatterns.com/uploads/rYVAskppSZUrooMruAGdNV/gcu-why-15-year-track-record.png'
}, {
  icon: Users,
  title: 'Built for Large Group Orders',
  desc: 'Organized support for sizes, colors, names, numbers, approvals, and multi-team program needs.',
  image: 'https://cdn.magicpatterns.com/uploads/xeNgSN4DrPx9ewX6hC35pR/gcu-why-built-for-large-group-orders.png'
}, {
  icon: Store,
  title: 'Team Stores & Rebates',
  desc: 'Create team-specific online stores and rebate opportunities for clubs, leagues, schools, and organizations.',
  image: 'https://cdn.magicpatterns.com/uploads/2HYt3218fbYp9MviDkEtdv/gcu-why-team-stores-rebates.png'
}, {
  icon: FileText,
  title: 'Quote Review',
  desc: "Have a quote? Send it to us and we'll help you compare.",
  image: 'https://cdn.magicpatterns.com/uploads/pmkv5kkqt3RgratXDv4RKo/gcu-why-quote-review.png'
}];
export function WhyChoosePts() {
  return <section className="py-20 bg-gray-50 border-y border-gray-200" data-id="element-305">
      <Container data-id="element-306">
        <div className="text-center mb-16" data-id="element-307">
          <h2 className="font-oswald text-4xl md:text-5xl font-bold uppercase mb-4 text-gray-900" data-id="element-308">
            Why Teams Choose PTS
          </h2>
          <div className="w-24 h-1.5 bg-pts-red mx-auto mb-6" data-id="element-309"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-310">
            We take the stress out of ordering custom team uniforms with
            factory-direct pricing and dedicated support.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-311">
          {BENEFITS.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow overflow-hidden flex flex-col h-full" data-id="element-312">
              {/* Benefit Illustration */}
              <div className="w-full h-44 bg-gray-50 relative overflow-hidden" data-id="element-313">
                <img src={benefit.image} alt={benefit.title} loading="lazy" className="w-full h-full object-cover object-center" data-id="element-314" />
              </div>

              <div className="p-8 flex flex-col flex-grow" data-id="element-315">
                <div className="w-12 h-12 bg-red-50 text-pts-red rounded-lg flex items-center justify-center mb-5" data-id="element-316">
                  <benefit.icon className="h-6 w-6" data-id="element-317" />
                </div>
                <h3 className="font-oswald text-2xl font-bold text-gray-900 uppercase mb-3" data-id="element-318">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed flex-grow" data-id="element-319">
                  {benefit.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}